import { call, put } from "redux-saga/effects";

import { apiGeneral, notify } from "services";
import { ICreateRequest } from "interfaces/create-duck";
import { requestErrorHandler } from "utils";
import { CreateClientContactActions } from "store/ducks/settings/client-contact";

export function* createClientContactRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.post,
      `/client-contact`,
      postData
    );

    const { data } = responseBody;
    yield put(CreateClientContactActions.success(data));
    notify("success", "Contato salvo com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(CreateClientContactActions.failure(errorMessage));
  }
}
